import { BEFORE_APP, SET_RATE, SET_ANN, APP_MODE } from './redux/types';

const initialState = {
    rate: null,
    rateAuth: false,
    annRate: null,
    annRateAuth: false,
    menuType: 1 // 1 = top right, 2 = top left
}

export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case SET_RATE:
            return {
                ...state,
                rate: action.payload,
                rateAuth: true
            }
        case SET_ANN:
            return {
                ...state,
                annRate: action.payload,
                annRateAuth: true
            }
        case APP_MODE:
            return {
                ...state,
                menuType: action.payload 
            }
        case BEFORE_APP:
            return {
                ...state,
                rate: null,
                rateAuth: false,
                annRate: null,
                annRateAuth: false
            }
        default:
            return {
                ...state
            }
    }
}